import { FormationDetailProps } from '@/types/formation';

export const epiFormation: FormationDetailProps = {
  id: '7',
  title: 'Formation EPI (Equipier de première intervention)',
  description: "Apprenez à identifier les risques d'incendie, à utiliser les moyens de première intervention et adoptez le comportement adéquat pour la sécurité de tous.",
  duration: '4 heures (1/2 journée)',
  category: 'Incendie',
  imageSrc: "/images/formations/epi1.webp",
  slug: 'equipier-premiere-intervention',
  reference: 'F-EPI',
  price: 'Sur devis – nous contacter',
  targetAudience: "Toute personne de l'entreprise",
  prerequisites: 'Être âgé de 18 ans\nÊtre apte médical',
  objectives: [
    "Identifier les indices annonciateurs d'un incendie et les moyens de propagation",
    "Utiliser efficacement un extincteur et maîtriser les différents moyens de première intervention",
    "Adopter les consignes de sécurité incendie et d'évacuation",
    "Adopter au quotidien un comportement préventif face au risque incendie en mettant en application les bonnes pratiques de prévention du risque incendie",
  ],
  program: [
    {
      title: 'Partie théorique 40%',
      items: [
        "Connaissance des consignes de sécurité, des procédures internes et des risques spécifiques",
        "L'organisation de la lutte contre l'incendie",
      ]
    },
    {
      title: 'Les incendies généraux et spécifiques',
      items: [
        "Naissance et évolution d'un feu",
        "Les causes d'un incendie",
        'Le triangle du feu',
        'Les classes de feu',
        'Les modes de propagation',
        "Les procédés d'extinction",
        "Les différents types d'extincteurs",
      ]
    },
    {
      title: "Les différents types d'extincteurs et les agents extincteurs",
      items: [
        "Principe de fonctionnement, méthodologie d'utilisation d'un extincteur et RIA A à jet bâton/lance",
      ]
    },
    {
      title: 'Les facteurs aggravants',
      items: [
        'Les fumées',
      ]
    },
    {
      title: "Conduite à tenir en cas d'alarme et d'évacuation",
      items: [
        "Système de l'évacuation",
        "Rôle des chargés d'évacuation, du guide et du serre-file, du point de rassemblement",
        "Dispositif d'aide à l'évacuation",
      ]
    },
    {
      title: 'La prévention des incendies',
      items: [
        'Règles de prévention',
        "Exercice d'évacuation",
      ]
    },
    {
      title: 'Partie pratique 60%',
      items: [
        "Visite de l'établissement et repérage des circuits d'évacuation et du matériel",
        "Manipulation de l'extincteur CO2 à pression permanente",
        "Mise en œuvre de l'extincteur CO2 à pression permanente",
        "Présentation et utilisation du matériel spécifique de l'équipe de première intervention (RIA)",
        "Exercices d'extinction sur feux réels",
      ]
    },
  ],
  pedagogicalMethods: [
    'Cours théoriques basés sur la formation, exercice sur feux réels',
  ],
  evaluationMethods: [
    "En jour de la formation : Questionnaire des besoins et positionnement de l'apprenant",
    'Pendant la formation : Atelier pratique en situation réelle + exercice application',
    'Fin de formation : QCM pour évaluation des acquis + évaluation de satisfaction à chaud',
    "Après la formation : Évaluation à froid pour vérifier les compétences de l'apprenant",
  ],
  certification: "Cette action de formation sera validée par une attestation de compétences nominative, après la réalisation du QCM final par l'apprenant.",
  registrationProcess: [
    'Inscription par téléphone, par email ou par le site internet',
    "Délai d'accès selon un agenda interne (le session de rattrapage transitoire 10 jours avant le début de la formation)",
  ],
  accessibilityCriteria: "Pour toute personne en situation d'handicap, nous sommes susceptibles d'accueillir les personnes ayant le mois d'obstacle ou prédisent pour réaliser cette situation.",
  formatterInfo: {
    name: 'Sebastien Davrainville - SDPSI Formation',
    phone: '06 22 61 54 80',
    email: 'sdpsiformation@orange.fr',
    website: 'www.sdpsi-formations.fr'
  }
};
